<div
    class="license-tier-select-card sel-license-tier-select-card"
    [ngClass]="{ 'license-tier-select-card--disabled': disabled }"
    (click)="onCardClick()"
    (keydown.enter)="onCardClick()"
    provideParentForm
>
    <div class="license-tier-select-card__container clr-wrapper">
        <avi-radio
            class="license-tier-select-card__radio"
            name="licence_tier_type"
            [value]="tierType"
            [(ngModel)]="tierInUse"
            [disabled]="disabled"
        >
            <div class="license-tier-select-card__content">
                <div class="license-tier-select-card__header">
                    <div class="license-tier-select-card__name sel-license-tier-select-card-name">
                        {{ l10nKeys.tierHeader | vtranslate : getTierTypeLabel(tierType) }}
                    </div>
                </div>

                <div class="license-tier-select-card__description">
                    {{ getTierTypeDescription(tierType) }}
                </div>
            </div>
        </avi-radio>
    </div>

    <!-- transcluded content for alert message -->
    <ng-content></ng-content>
</div>
